export default "__VITE_ASSET__fde63389__"